import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { getLanguage } from '../selectors/getLanguage';
import { getSafeLanguagePath } from '../languageHelpers';
import { resourcePath } from '@gameday/utils/resource-path';
import { getTeamInfoState } from '../selectors/getTeamInfo';
import { createSelector } from 'reselect';

const teamMap = {};
const getDisableTeamPageLink = (state) => state.config?.disableTeamPageLink;
const getUseFallbackTeamUrl = (state) => state.config?.useFallbackTeamUrl;

const getDisableTeamPageLinkState = createSelector(
    [getDisableTeamPageLink],
    (disableTeamPageLink) => (disableTeamPageLink)
);

const getUseFallbackTeamUrlState = createSelector(
    [getUseFallbackTeamUrl],
    (useFallbackTeamUrl) => (useFallbackTeamUrl)
);

const findTeamId = (teamInfo, id) => {
    if (typeof id === 'undefined' || teamMap[id]) {
        return teamMap;
    };

    for (let j = 0; j < teamInfo?.length; j++) {
        if (teamInfo[j].id === id) {
            teamMap[id] = teamInfo[j];
            return teamMap;
        }
    }
};

const getFallbackUrl = (teamName) => {
    if (!teamName) {
        return '';
    }

    return teamName?.toLowerCase()?.replaceAll('-', '')?.split(' ')?.join('');
};

export const useTeamUrl = (id) => {
    const teamInfo = useSelector(getTeamInfoState);
    const language = useSelector(getLanguage);
    const disableTeamPageLink = useSelector(getDisableTeamPageLinkState);
    const useFallbackTeamUrl = useSelector(getUseFallbackTeamUrlState);

    return useMemo(() => {
        if (!teamInfo || !id || disableTeamPageLink) {
            return;
        }

        findTeamId(teamInfo, id);

        if (!teamMap?.[id]) {
            return '';
        }
        const { slug, teamName } = teamMap?.[id];
        let clubSlug = slug;

        if (!slug && useFallbackTeamUrl) {
            clubSlug = getFallbackUrl(teamName);
        }

        if (!clubSlug) {
            return undefined;
        }
        return resourcePath.get('teamUrl', { slug: clubSlug, languagePath: getSafeLanguagePath(language) });
    }, [teamInfo, id, language]);
};
